document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('[mente-description-carousel]');
  if (!carousel) return;

  const imageTrack = carousel.querySelector('.mente-description-carousel__image-track');
  const textSlides = carousel.querySelectorAll('.mente-text-slide');
  const textTrack = carousel.querySelector('.mente-text-track');

  let currentIndex = 0;
  const totalSlides = textSlides.length;

  if (totalSlides === 0) return;
  textSlides[0].classList.add('is-active');

  // Use event delegation for button clicks
  textTrack.addEventListener('click', (e) => {
    if (!e.target.matches('[mente-description-carousel-next]')) return;
    e.preventDefault();

    const prevIndex = currentIndex;
    currentIndex = (currentIndex + 1) % totalSlides;

    textSlides[prevIndex].classList.remove('is-active');
    textSlides[currentIndex].classList.add('is-active');

    imageTrack.style.transform = `translateX(-${currentIndex * 100}%)`;
  });
});
